import { ChevronLeft, ChevronRight } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function PaginationBar({ page, hasMore, onPageChange, loading }) {
  const pages = generatePageNumbers(page, hasMore);

  return (
    <div className="flex items-center justify-center gap-1.5 sm:gap-2 px-3 sm:px-6 py-5 sm:py-8">
      <button
        data-testid={HOME.paginationPrev}
        disabled={page <= 1 || loading}
        onClick={() => onPageChange(page - 1)}
        className="h-9 w-9 sm:w-auto sm:px-4 flex items-center justify-center gap-1 bg-transparent border border-white/10 text-white/60 hover:text-white hover:border-white/20 hover:bg-white/5 rounded-full sm:rounded-xl disabled:opacity-20 disabled:cursor-not-allowed cursor-pointer text-xs transition-colors"
      >
        <ChevronLeft className="w-4 h-4" />
        <span className="hidden sm:inline">Anterior</span>
      </button>

      {pages.map((p) => (
        <button
          key={p}
          data-testid={`${HOME.paginationPage}-${p}`}
          onClick={() => p !== page && onPageChange(p)}
          disabled={loading}
          className={`w-9 h-9 rounded-full sm:rounded-xl text-xs sm:text-sm font-mono transition-all cursor-pointer ${
            p === page
              ? "bg-[#007AFF] text-white font-semibold"
              : "text-white/40 hover:text-white/70 hover:bg-white/5"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        data-testid={HOME.paginationNext}
        disabled={!hasMore || loading}
        onClick={() => onPageChange(page + 1)}
        className="h-9 w-9 sm:w-auto sm:px-4 flex items-center justify-center gap-1 bg-transparent border border-white/10 text-white/60 hover:text-white hover:border-white/20 hover:bg-white/5 rounded-full sm:rounded-xl disabled:opacity-20 disabled:cursor-not-allowed cursor-pointer text-xs transition-colors"
      >
        <span className="hidden sm:inline">Próxima</span>
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
}

function generatePageNumbers(current, hasMore) {
  const pages = [];
  const start = Math.max(1, current - 2);
  const end = hasMore ? current + 2 : current;
  for (let i = start; i <= end; i++) pages.push(i);
  return pages;
}
